/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useEffect } from 'react';
import { CoreContext } from '../../../context/CoreContext';
import { availableUsers } from '../../../services/mock';
import ProfileItem from '../../ProfileItem';
import ModalWrapper from '../Wrapper';

import {
  ContentModalOut,
  ContentModalTitle,
  ContentModalIn,
  UserContent,
  UserContentImage,
  UserContentText,
} from './styled';

export default function ModalSelectProfile({
  setFocus,
}: {
  setFocus?: (key: string) => void;
  // Passed by ModalCore; the modal self-gates on context, so it's accepted but unused.
  opened?: boolean;
}) {
  const { setCurrentProfile, setModal, profiles } = useContext(CoreContext);

  const selectProfile = (item: Record<string, unknown>) => {
    setCurrentProfile(item as { id: number | string; [key: string]: unknown });
    setModal(null);
  };

  const handleBlurred = () => {
    setModal(null);
  };

  useEffect(() => {
    if (setFocus && typeof setFocus === 'function') {
      setFocus('profile-1');
    }
  }, []);
  return (
    <>
      <ModalWrapper onBecameBlurred={handleBlurred}>
        <ContentModalOut>
          <ContentModalTitle>Trocar perfil</ContentModalTitle>
          <ContentModalIn>
            {profiles.map((item: Record<string, unknown>, key: number) => (
              <ProfileItem
                key={key}
                onEnterPress={() => selectProfile(item)}
                onPress={() => selectProfile(item)}
                item={item}
                focusKey={`profile-${key + 1}`}
              />
            ))}
          </ContentModalIn>
        </ContentModalOut>
      </ModalWrapper>
    </>
  );
}
